var _rect, _rect2, _rect3, _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgSpaceTemplatePlaylist = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 32,
    viewBox: "0 0 56 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48.0002,
    height: 16.0001,
    transform: "matrix(1 0 -5.44074e-05 1 0.000976562 -6.10352e-05)",
    fill: "#9FEEC9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 8.00003,
    height: 8.00003,
    transform: "matrix(1 -1.53054e-09 -5.46861e-05 1 3.99902 3.99994)",
    fill: "black",
    fillOpacity: 0.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 28.0001,
    height: 8.00003,
    transform: "matrix(1 7.24982e-08 -5.46112e-05 1 15.999 3.99994)",
    fill: "black",
    fillOpacity: 0.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.9991,
    cy: 20,
    r: 10,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.999 30C38.476 30 33.999 25.523 33.999 20C33.999 14.477 38.476 10 43.999 10C49.522 10 53.999 14.477 53.999 20C53.999 25.523 49.522 30 43.999 30ZM42.621 16.415C42.5608 16.3748 42.4909 16.3518 42.4186 16.3482C42.3464 16.3447 42.2745 16.3608 42.2107 16.3949C42.1468 16.4289 42.0935 16.4797 42.0562 16.5417C42.0189 16.6037 41.9992 16.6747 41.999 16.747V23.253C41.9992 23.3253 42.0189 23.3963 42.0562 23.4583C42.0935 23.5203 42.1468 23.5711 42.2107 23.6051C42.2745 23.6392 42.3464 23.6553 42.4186 23.6518C42.4909 23.6482 42.5608 23.6252 42.621 23.585L47.5 20.333C47.5549 20.2965 47.5999 20.247 47.631 20.1889C47.6621 20.1308 47.6784 20.0659 47.6784 20C47.6784 19.9341 47.6621 19.8692 47.631 19.8111C47.5999 19.753 47.5549 19.7035 47.5 19.667L42.621 16.415Z",
    fill: "#594BFE"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgSpaceTemplatePlaylist);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/space-template-playlist.6049eefd134c08265ef7f5e5eb2a04a4.svg";